import "./styles/App.css";
import { useContext, useEffect } from "react";
import MyRoutes from "./component/routes";
import { GlobalContext } from "./context/Context";
import AsideBar from "./component/layout/aside";
import { useApiCall } from "./component/custom-hooks/api-call";
import axios from "axios";
import InnerLoader from "./component/ui/loader/inner-loader";
import { useLocation } from "react-router";

function App() {
  let { state, dispatch } = useContext(GlobalContext);
  const apiCall = useApiCall();
  const checkUser = async () => {
    console.log("Check User Called");
    let userToken =
      sessionStorage.getItem("agent_token") || localStorage.getItem("token");
    let userData = JSON.parse(
      sessionStorage.getItem("agent_user") || localStorage.getItem("user")
    );

    if (!userToken) {
      dispatch({ type: "USER_LOGOUT" });
      return;
    }
    axios.defaults.headers.common["Authorization"] = `Bearer ${userToken}`;
    try {
      //let apiRes = await apiCall({ url: 'brands/list', method: 'get', customToken: userToken });
      dispatch({ type: "USER_LOGIN", payload: userData, token: userToken });
      // getCoverPhotos(userToken)
      //  getDropdowns(userToken);
      // if(apiRes?.timeInEnabled == "yes"){
      //   dispatch({ type: 'TIME_OUT', payload: apiRes?.time_activity, hours: apiRes?.hrs });
      // }else{
      //   dispatch({ type: 'TIME_IN', payload: apiRes?.time_activity });
      // }
    } catch (error) {
      console.error("Error : ", error);
    }
  };

  const getDropdowns = async (token) => {
    try {
      let data = {};
      const [d1, d2, d3] = await Promise.all([
        apiCall({
          url: "get-department-list",
          method: "get",
          customToken: token,
        }),
        apiCall({
          url: "get-active-employee-list",
          method: "get",
          customToken: token,
        }),
        apiCall({
          url: "get-employee-shift-list",
          method: "get",
          customToken: token,
        }),
      ]);
      data = {
        departmentList: d1?.departmentList,
        activeEmployeeList: d2?.activeEmployeeList,
        shiftList: d3?.shiftList,
      };
      dispatch({ type: "SET_DROPDOWN", payload: data });
    } catch (error) {
      console.error("Dropdown load error:", error);
    }
  };

  useEffect(() => {
    const checkIsUserLogin = async () => {
      try {
        const apiRes = await axios.get('https://api.ipify.org?format=json');
        dispatch({ type: "SET_IP", payload: apiRes.data.ip })
        checkUser()
      } catch (error) {

      }
    }
    checkIsUserLogin()
    checkUser();

  }, []);

  // new changes
  //  BrandList = [],
  // PackageList = [],
  // DealStages = [],
  // Countries = [],
  // CustomerData = {},
  // UsersList = [],

  const Modal = async () => {
    let data = {};

    try {
      const brandResponse = await apiCall({
        method: "get",
        url: "brands/brands-list?is_paginate=0",
      });

      const packageResponse = await apiCall({
        method: "get",
        url: `brands/brand-packages-list?is_paginate=0`,
      });

      const stagesResponse = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });


      const filteredStages = stagesResponse.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost"
      );

      const countriesResponse = await apiCall({
        method: "get",
        url: `location/get-countries`,
      });


      const usersResponse = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      const newUsers =
        usersResponse?.agents ||
        usersResponse?.customers ||
        usersResponse?.data ||
        [];

      data = {
        BrandList: brandResponse?.data || [],
        PackageList: packageResponse?.data || [],
        DealStages: filteredStages || [],
        Countries: countriesResponse?.data || [],
        UsersList: newUsers || [],
      };

      dispatch({ type: "SET_MODAL_DATA", payload: data });

      console.log("data", data);

    } catch (error) {
      console.warn("Error Modal:", error);

      console.log("afjfaofgoadodsohoi");

    } finally {
      console.log("Modal log");

    }
  };

  const location = useLocation()

  const getCoverPhotos = async (token) => {
    try {
       const res = await apiCall({
        url: 'list-cover-picture', method: 'get', customToken: token 
        });
      
    } catch (error) {
      console.log(error);
      
      
    }
  }

  const isHeaderHide = location.pathname == "/lead-package"

  return (
    <>
      {(state.isLogin == true && !isHeaderHide) ? (
        <main className="webPage">
          <AsideBar />
          <MyRoutes />
        </main>
      ) : (state.isLogin == false || isHeaderHide) ? (
        <MyRoutes />
      ) : (
        <div
          className=""
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* <CircularProgress sx={{ color: "#2563eb" }} size={100} /> */}
          <InnerLoader />
        </div>
      )}

      <svg style={{ display: "none" }}>
        <filter
          id="glass-distortion"
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
        >
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.01 0.01"
            numOctaves="1"
            seed="5"
            result="turbulence"
          />

          <feComponentTransfer in="turbulence" result="mapped">
            <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
            <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
            <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
          </feComponentTransfer>

          <feGaussianBlur in="turbulence" stdDeviation="10" result="softMap" />

          <feSpecularLighting
            in="softMap"
            surfaceScale="5"
            specularConstant="1"
            specularExponent="100"
            lightingColor="white"
            result="specLight"
          >
            <fePointLight x="-200" y="-200" z="300" />
          </feSpecularLighting>

          <feComposite
            in="specLight"
            operator="arithmetic"
            k1="0"
            k2="1"
            k3="1"
            k4="0"
            result="litImage"
          />

          <feDisplacementMap
            in="SourceGraphic"
            in2="softMap"
            scale="150"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </svg>
    </>
  );
}

export default App;
